import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Spinner, Alert } from 'react-bootstrap';
import { getPublicDocument } from 'services/documentService';
import styles from './PublicDocument.module.scss';

const PublicDocument = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [document, setDocument] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadDocument = async () => {
      try {
        const response = await getPublicDocument(token);
        const { data } = response || {};
        setDocument(data);
      } catch (err) {
        const errorMessage = err?.response?.data?.error || 'Document not found or sharing is disabled';
        setError(errorMessage);
      } finally {
        setLoading(false);
      }
    };

    loadDocument();
  }, [token]);

  const renderHeader = () => (
    <header className={styles.header}>
      <div className={styles.headerContent}>
        <div className={styles.logoSection} onClick={() => window.location.href = 'https://vocable.ai'}>
          <img
            src="/Images/vocablebalck_greeen.svg"
            alt="Vocable"
            className={styles.logo}
          />
        </div>
        <div className={styles.authButtons}>
          <button
            className={styles.signInButton}
            onClick={() => navigate('/sign-in')}
          >
            Sign In
          </button>
          <button
            className={styles.signUpButton}
            onClick={() => navigate('/sign-up')}
          >
            Get Started
          </button>
        </div>
      </div>
    </header>
  );

  if (loading) {
    return (
      <>
        {renderHeader()}
        <Container className={styles.container}>
          <div className={styles.centerContent}>
            <Spinner animation="border" variant="primary" />
            <p className={styles.loadingText}>Loading document...</p>
          </div>
        </Container>
      </>
    );
  }

  if (error) {
    return (
      <>
        {renderHeader()}
        <Container className={styles.container}>
          <Alert variant="danger" className={styles.alert}>
            <Alert.Heading>Unable to load document</Alert.Heading>
            <p>{error}</p>
          </Alert>
        </Container>
      </>
    );
  }

  return (
    <>
      {renderHeader()}
      <Container className={styles.container}>
        <div className={styles.documentWrapper}>
          <div className={styles.documentHeader}>
            <h1 className={styles.documentTitle}>{document?.title}</h1>
            <div className={styles.documentMeta}>
              {document?.shared_by && (
                <small className={styles.sharedBy}>
                  Shared by: <strong>{document.shared_by.name}</strong>
                </small>
              )}
              <small className={styles.lastUpdated}>
                Last updated: {new Date(document?.updated_at).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
              </small>
            </div>
          </div>

          <div
            className={styles.documentContent}
            dangerouslySetInnerHTML={{ __html: document?.content }}
          />

          <div className={styles.footer}>
            <div className={styles.ctaSection}>
              <h3 className={styles.ctaTitle}>Create documents like this with Vocable</h3>
              <p className={styles.ctaDescription}>
                Join thousands of content creators using Vocable to write, collaborate, and publish faster.
              </p>
              <button
                className={styles.ctaButton}
                onClick={() => navigate('/sign-up')}
              >
                Start Your Free Trial
              </button>
            </div>
            <div className={styles.footerDivider}></div>
            <small className={styles.poweredBy}>
              Powered by <a href="https://vocable.ai" target="_blank" rel="noopener noreferrer" className={styles.vocableLink}><strong>Vocable</strong></a> - AI-powered content creation platform
            </small>
          </div>
        </div>
      </Container>
    </>
  );
};

export default PublicDocument;
